import { Search, ClipboardCheck, FileText, ShieldCheck } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: Search,
    title: "Discover",
    desc: "We identify the property type, exposure, risk concerns, legal context, and documentation goals.",
  },
  {
    n: "02",
    icon: ClipboardCheck,
    title: "Inspect",
    desc: "We coordinate property review, field documentation, expert input, and condition assessment.",
  },
  {
    n: "03",
    icon: FileText,
    title: "Document",
    desc: "We create organized, litigation-ready reports with visuals, findings, estimates, and strategic risk notes.",
  },
  {
    n: "04",
    icon: ShieldCheck,
    title: "Protect",
    desc: "We give owners, boards, and attorneys the intelligence needed to act before exposure becomes liability.",
  },
];

export const Process = () => {
  return (
    <section id="reports" className="relative py-20 sm:py-24 md:py-36 overflow-hidden btr-bg-glow" data-testid="process-section">
      <div className="absolute inset-0 btr-grid-animated opacity-30 pointer-events-none" />
      <div className="btr-beam btr-beam-drift" style={{ width: 500, height: 500, top: "-10%", right: "0%", background: "#a2020b", opacity: 0.2 }} />

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="btr-reveal max-w-3xl">
          <span className="btr-badge">
            <span className="dot" />
            Our Process
          </span>
          <h2 className="font-display font-extrabold text-white text-3xl sm:text-4xl lg:text-6xl mt-6 leading-[1.05] sm:leading-[1.02] tracking-tight">
            Our Protection Process
          </h2>
          <p className="font-body text-zinc-400 text-base sm:text-lg mt-6 leading-relaxed">
            A disciplined four-step methodology engineered for clarity, defensibility, and executive decision-making.
          </p>
        </div>

        <div className="relative mt-16">
          {/* Connecting line */}
          <div className="hidden lg:block absolute top-[74px] left-[6%] right-[6%] h-[1px] bg-gradient-to-r from-transparent via-[#a2020b]/50 to-transparent" />

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {STEPS.map((s, i) => {
              const Icon = s.icon;
              return (
                <div
                  key={s.n}
                  className="btr-reveal relative btr-glass rounded-lg p-7 group hover:border-[#a2020b]/45 transition-colors"
                  style={{ transitionDelay: `${i * 80}ms` }}
                  data-testid={`process-step-${i}`}
                >
                  <div className="relative w-14 h-14 rounded-full bg-[#0a0a0a] border border-[#a2020b]/40 flex items-center justify-center mx-auto btr-red-glow">
                    <Icon className="w-5 h-5 text-[#a2020b]" strokeWidth={1.5} />
                  </div>
                  <div className="font-display text-[10px] tracking-[0.3em] uppercase text-zinc-500 mt-5 text-center">
                    Step {s.n}
                  </div>
                  <div className="font-display font-bold text-white text-xl mt-2 text-center tracking-tight">
                    {s.title}
                  </div>
                  <p className="font-body text-zinc-400 text-sm mt-3 text-center leading-relaxed">{s.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
